export const unflaggedDueDateGroupLabel = "Wz5jUc";
export const noDateGroupLabel = "Ita9nd";
export const laterGroupLabel = "ry2Emc";
export const nextWeekGroupLabel = "w5_Sx";
export const thisWeekGroupLabel = "x40Zqb";
export const tomorrowGroupLabel = "KHSVY";
export const todayGroupLabel = "eR8ku";
export default {unflaggedDueDateGroupLabel,noDateGroupLabel,laterGroupLabel,nextWeekGroupLabel,thisWeekGroupLabel,tomorrowGroupLabel,todayGroupLabel};